import { useState } from 'react'
import toast from 'react-hot-toast'
import { copiarTextoSeguro } from '../utils/clipboard.mjs'

export default function OneTimeSecretDialog({ secret, titulo = 'Secret configurado', onConfirm }) {
  const [guardado, setGuardado] = useState(false)

  const copiar = async () => {
    const resultado = await copiarTextoSeguro(secret)
    if (resultado.copiado) {
      toast.success('Secret copiado al portapapeles')
    } else {
      toast.error('No se pudo copiar. Selecciona y copia el secret manualmente; seguirá visible aquí.')
    }
  }

  return (
    <div role="dialog" aria-modal="true" aria-labelledby="one-time-secret-title" style={{
      position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(15, 23, 42, .72)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }}>
      <div className="card" style={{ width: 'min(620px, 100%)', padding: 24 }}>
        <h2 id="one-time-secret-title" style={{ fontSize: 18, marginBottom: 8 }}>{titulo}</h2>
        <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 14 }}>
          Este valor solo se muestra ahora. Guárdalo en el receptor del webhook antes de confirmar.
        </p>
        <input className="input" aria-label="Secret mostrado una sola vez" value={secret} readOnly
          onFocus={e => e.currentTarget.select()} style={{ fontFamily: 'monospace' }} />
        <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
          <button type="button" className="btn btn-primary" onClick={copiar}>Copiar secret</button>
        </div>
        <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: 18, fontSize: 13 }}>
          <input type="checkbox" checked={guardado} onChange={e => setGuardado(e.target.checked)} />
          Confirmo que guardé el secret en un lugar seguro.
        </label>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 14 }}>
          <button type="button" className="btn" disabled={!guardado} onClick={onConfirm}>
            Ya lo guardé
          </button>
        </div>
      </div>
    </div>
  )
}
